export default __webpack_public_path__ + "static/media/CNo.33-10.24fd7097.jpg";